// Words card game data with rankings (by frequency)
export const WORD_CARDS = [
  { id: 1, name: "the", rank: 1 , image: "/images/word/word_1.jpg"},
  { id: 2, name: "be", rank: 2 , image: "/images/word/word_2.jpg"},
  { id: 3, name: "to", rank: 3 , image: "/images/word/word_3.jpg"},
  { id: 4, name: "of", rank: 4 , image: "/images/word/word_4.jpg"},
  { id: 5, name: "and", rank: 5 , image: "/images/word/word_5.jpg"},
  { id: 6, name: "a", rank: 6 , image: "/images/word/word_6.jpg"},
  { id: 7, name: "in", rank: 7 , image: "/images/word/word_7.jpg"},
  { id: 8, name: "that", rank: 8 , image: "/images/word/word_8.jpg"},
  { id: 9, name: "have", rank: 9 , image: "/images/word/word_9.jpg"},
  { id: 10, name: "I", rank: 10 , image: "/images/word/word_10.jpg"},
  { id: 11, name: "it", rank: 11 , image: "/images/word/word_11.jpg"},
  { id: 12, name: "for", rank: 12 , image: "/images/word/word_12.jpg"},
  { id: 13, name: "not", rank: 13 , image: "/images/word/word_13.jpg"},
  { id: 14, name: "on", rank: 14 , image: "/images/word/word_14.jpg"},
  { id: 15, name: "with", rank: 15 , image: "/images/word/word_15.jpg"},
  { id: 16, name: "he", rank: 16 , image: "/images/word/word_16.jpg"},
  { id: 17, name: "as", rank: 17 , image: "/images/word/word_17.jpg"},
  { id: 18, name: "you", rank: 18 , image: "/images/word/word_18.jpg"},
  { id: 19, name: "do", rank: 19 , image: "/images/word/word_19.jpg"},
  { id: 20, name: "at", rank: 20 , image: "/images/word/word_20.jpg"},
  { id: 21, name: "this", rank: 21 , image: "/images/word/word_21.jpg"},
  { id: 22, name: "but", rank: 22 , image: "/images/word/word_22.jpg"},
  { id: 23, name: "his", rank: 23 , image: "/images/word/word_23.jpg"},
  { id: 24, name: "by", rank: 24 , image: "/images/word/word_24.jpg"},
  { id: 25, name: "from", rank: 25 , image: "/images/word/word_25.jpg"},
  { id: 26, name: "they", rank: 26 , image: "/images/word/word_26.jpg"},
  { id: 27, name: "we", rank: 27 , image: "/images/word/word_27.jpg"},
  { id: 28, name: "say", rank: 28 , image: "/images/word/word_28.jpg"},
  { id: 29, name: "her", rank: 29 , image: "/images/word/word_29.jpg"},
  { id: 30, name: "she", rank: 30 , image: "/images/word/word_30.jpg"}
];